module.exports = __webpack_public_path__ + "static/media/Santa Rosa Avenue, Santa Barbara, CA2.16df6329.jpg";